module.exports = __webpack_public_path__ + "img/whiteBg.4f15a378.png";